/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatsByRegionWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ThreatsByRegionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ThreatsByRegionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ThreatsByRegionWidgetConfiguration>): ThreatsByRegionWidgetConfiguration {
        let obj = Object.assign(new ThreatsByRegionWidgetConfiguration(), model);
        ThreatsByRegionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatsByRegionWidgetConfiguration>): ThreatsByRegionWidgetConfiguration {
        if (!model) return null;
        return ThreatsByRegionWidgetConfiguration.newInstance(<ThreatsByRegionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatsByRegionWidgetConfiguration) {
        if (!obj) return;

        models.ThreatsByRegionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatsByRegionWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatsByRegionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
